export enum ServerType {
  Standard = 'Standard',
  Database = 'Database'
}
